/* eslint-disable no-undef */
import $ from 'jquery';
import { Component } from 'react';
import WidgetContainer from 'legacy/javascripts/components/widget_container.es6.jsx';
import StellaError from 'legacy/javascripts/components/stella_error.es6.jsx';
import StellaLoading from 'legacy/javascripts/components/stella_loading.es6.jsx';
import DateRangePicker from 'legacy/javascripts/components/date_range_picker.es6';

import widgets from 'legacy/javascripts/components/widgets';
import { shortUsaDateFormat } from 'common/utils/date';

class ServiceRecoveryDashboard extends Component {
  constructor() {
    super();
    this.onDateRangeApply = this.onDateRangeApply.bind(this);
    this.state = {
      loading: true,
      error: false,
      dateRange: DateRangeQueryString.dateRange(),
    };
  }

  onDateRangeApply(_event, picker) {
    const dateRange = {
      start: picker.startDate,
      end: picker.endDate,
      label:
        picker.chosenLabel !== picker.locale.customRangeLabel
          ? picker.chosenLabel
          : undefined,
      solicitation_reporting_timestamp: picker.timestamp,
    };

    this.setState({ dateRange });
    this.refresh();
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    DateRangeQueryString.setDateRange(this.state.dateRange, shortUsaDateFormat);

    this.setState({ loading: true });
    $.ajax({
      url: `${window.location.pathname}${window.location.search}`,
      cache: false,
      dataType: 'json',
      success: data => {
        data.loading = false;
        this.setState({
          ...data,
          dateRange: DateRangeQueryString.dateRange(),
        });
      },
      error: () => {
        this.setState({ error: true, loading: false });
      },
    });
  }

  displayWidgets() {
    return (
      <div>
        <div className="service-recovery-dashboard">
          <div className="row">
            <div className="col-md-12">
              <WidgetContainer
                title={this.state.service_recovery_funnel.label}
                data={this.state.service_recovery_funnel.data}
                widget={widgets[this.state.service_recovery_funnel.klass]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 tags-header">
              <WidgetContainer
                title={this.state.do_not_send_categories.label}
                data={this.state.do_not_send_categories.data}
                widget={widgets[this.state.do_not_send_categories.klass]}
              />
            </div>
            <div className="col-md-6 tags-header">
              <WidgetContainer
                title={this.state.follow_up_categories.label}
                data={this.state.follow_up_categories.data}
                widget={widgets[this.state.follow_up_categories.klass]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <WidgetContainer
                title={this.state.recovery_by_team_member.label}
                data={this.state.recovery_by_team_member.data}
                widget={widgets[this.state.recovery_by_team_member.klass]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <span>Filter date </span>
        <label htmlFor="daterange" className="datepicker-wrapper">
          <DateRangePicker
            onApply={this.onDateRangeApply}
            range={this.state.dateRange}
          />
        </label>
        <StellaLoading
          loading={this.state.loading}
          loadingImage={this.props.loading_image}
        />
        <StellaError
          error={this.state.error}
          errorImage={this.props.error_image}
        />
        {this.loadedComponents()}
      </div>
    );
  }

  loadedComponents() {
    if (!this.state.loading && !this.state.error) {
      return <div>{this.displayWidgets()}</div>;
    }
  }
}

export default ServiceRecoveryDashboard;
/* eslint-enable no-undef */
